import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { useAuth } from "@/lib/auth";

export const AvisoSinGrupoTarifa = ({ testId }) => {
  const { tienePermiso } = useAuth();
  return (
    <div data-testid={testId || "aviso-sin-grupo-tarifa"}
      className="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800">
      <AlertTriangle size={15} className="mt-0.5 shrink-0" />
      <span>
        Este modelo no tiene grupo tarifario: la mano de obra por FRT sale en ₡0.{" "}
        {tienePermiso("mant.modelos")
          ? <Link to="/modelos" className="font-medium underline hover:text-amber-900">Asígnelo en Modelos.</Link>
          : "Asígnelo en Modelos."}
      </span>
    </div>
  );
};
